import React from 'react';
export function Footer() {
  return <footer className="bg-zinc-950 py-12 border-t border-tactical-border text-center" data-id="element-49">
      <div className="container mx-auto px-4" data-id="element-50">
        <h4 className="font-oswald text-2xl uppercase tracking-widest text-zinc-700 mb-6" data-id="element-51">
          Protocolo Actuar Es Ganar
        </h4>
        <div className="flex justify-center gap-6 text-sm text-zinc-600 font-mono uppercase mb-8" data-id="element-52">
          <a href="#" className="hover:text-tactical-accent transition-colors" data-id="element-53">
            Términos
          </a>
          <a href="#" className="hover:text-tactical-accent transition-colors" data-id="element-54">
            Privacidad
          </a>
          <a href="#" className="hover:text-tactical-accent transition-colors" data-id="element-55">
            Soporte
          </a>
        </div>
        <p className="text-xs text-zinc-700 font-mono" data-id="element-56">
          &copy; {new Date().getFullYear()} Autoridad Global. Todos los derechos
          reservados. <br data-id="element-57" />
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </div>
    </footer>;
}